import React from 'react'
import { Icon, Link } from '@afterpaytouch/core'
import { CheckoutPage, TrackingEvent } from '../../model'
import { ProfileCreated } from '@afterpaytouch/registration'
import { useCheckoutSizes } from '../../utils/responsive'
import { useTranslation, Trans } from '../../utils/convergence'
import { usePostLoginRoute } from '../../config/router'
import { useAppRouter } from '../../state'
import { TrackPageViewed, useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'

export const ProfileCreatedPage: CheckoutPage = () => {
  const { headingSize, textSize } = useCheckoutSizes()
  const { t } = useTranslation()
  const postLoginRoute = usePostLoginRoute()
  const router = useAppRouter()
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  const handleCtaClick = (): void => {
    logEvent(TrackingEvent.PRESSED_PROFILE_CREATED_PAGE_CONTINUE_BUTTON)
    router.push(postLoginRoute)
  }

  const items = [
    { icon: <Icon.History />, text: t('profileCreated:disclaimers:item0') },
    { icon: <Icon.NoCreditCheck />, text: t('profileCreated:disclaimers:item1') },
    { icon: <Icon.Search />, text: t('profileCreated:disclaimers:item2') },
  ]

  const contactElement = (
    <Trans
      i18nKey='profileCreated:contact'
      components={{
        contactLink: <Link target='_blank' kind='Underline' href={t('profileCreated:contactUrl')} />,
      }}
    />
  )

  return (
    <>
      <ProfileCreated
        headingSize={headingSize}
        textSize={textSize}
        ctaButtonSize='Large'
        onCtaClick={handleCtaClick}
        contactElement={contactElement}
        t={t}
        items={items}
      />
      <TrackPageViewed />
    </>
  )
}
